<template>
  <DataTable
    :columns="columnList"
    defaultColumnOrderDir="DESC"
    :defaultColumnOrderIndex="6"
    :url="dataURL"
    emptyListMessage="No invoices found"
    :filterOptions="filterOptions"
    :displayTools="true"
    :hasDateRangeFilter="true"
    :displayLocationFilter="displayLocationFilter"
    :displayFilters="displayFilters"
    :displayDateFilter="displayDateFilter"
    :displayExportTools="displayExportTools"
    :displaySearch="displaySearch"
    :displayPageCount="displayPageCount"
    :displayFooterNote="displayFooterNote"
    exportTitle="Invoices">

    <template v-slot:title>
      <slot name="title" />
    </template>
    <template v-slot:tools>
      <slot name="tools" />
    </template>
    <template v-slot:row="row">
      <tr :key="row.data.id">
        <td class="table-data-nav-link">
          <LinkInvoice :name="'#'+row.data.sequenceNumber" :id="row.data.id" :newTab="openNewTab" />
        </td>
        <td>
          <LinkContact :id="row.data.contactId" :name="row.data.contactName" />
        </td>
        <td>
          {{row.data.customerRef | formatHyphenEmptyValue}}
        </td>
        <td>
          <LabelBadge :labelClass="`label-invoice-status-${row.data.status}`">{{row.data.status | formatLookupName(InvoiceStatusTypeLookup)}}</LabelBadge>
        </td>
        <td>
          <LabelBadge :labelClass="`label-credit-type-${row.data.creditType}`">{{row.data.creditType | formatLookupName(CreditTypeLookup)}}</LabelBadge>
        </td>
        <td>
          <LabelAccountLocationBadge :accountLocation="row.data.accountLocation" />
        </td>
        <td>{{row.data.dateInvoiceCreated | formatDateTime}}</td>
        <td>
          <span :class="{'financial-loss': isInvoiceOverdue(row.data.dateDue, row.data.status)}">{{row.data.dateDue | formatDate}}</span>
        </td>
        <td>{{row.data.totalPrice | formatCurrency}}</td>
        <td>
          <span :class="{'financial-loss': isInvoiceOverdue(row.data.dateDue, row.data.status)}">{{row.data.amountDue | formatCurrency}}</span>
        </td>
      </tr>
    </template>
    <template v-slot:summary="summary">
      <tr key="summary">
        <td>Totals</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{summary.data.totalInvoicePrice | formatCurrency}}</td>
        <td>{{summary.data.totalInvoiceAmountDue | formatCurrency}}</td>
      </tr>
    </template>
  </DataTable>
</template>

<script>
import moment from 'moment'
import Utils from '@/utils/utils'

import { InvoiceStatusTypes, InvoiceStatusTypeLookup, CreditTypes, CreditTypeLookup } from '@/store/types'

export default {
  name: "InvoiceDataTable",
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    displaySearch: {
      type: Boolean,
      default: true
    },
    displayPageCount: {
      type: Boolean,
      default: true
    },
    displayExportTools: {
      type: Boolean,
      default: true
    },
    displayFilters: {
      type: Boolean,
      default: true
    },
    displayLocationFilter: {
      type: Boolean,
      default: true
    },
    displayDateFilter: {
      type: Boolean,
      default: true
    },
    displayFooterNote: {
      type: Boolean,
      default: true
    },
    filterContactId: Number,
    filterOrderId: Number,
    filterType: String
  },
  created() {
    this.InvoiceStatusTypeLookup = InvoiceStatusTypeLookup
    this.CreditTypeLookup = CreditTypeLookup
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {}
      }
      if(this.filterContactId)
        params.filter.contactId = this.filterContactId
      if(this.filterOrderId)
        params.filter.orderId = this.filterOrderId

      return '/accounts/invoices?' + $.param(params)
    },
  },
  data() {
    return {
      filterOptions: [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(InvoiceStatusTypeLookup, InvoiceStatusTypes.invoiced), value: InvoiceStatusTypes.invoiced, class: 'label-invoice-status-invoiced' },
            { name: Utils.getLookupName(InvoiceStatusTypeLookup, InvoiceStatusTypes.paid), value: InvoiceStatusTypes.paid, class: 'label-invoice-status-paid' },
            { name: Utils.getLookupName(InvoiceStatusTypeLookup, InvoiceStatusTypes.cancelled), value: InvoiceStatusTypes.cancelled, class: 'label-invoice-status-cancelled' }
          ]
        },
        {
          field: 'creditType',
          name: 'Credit Type',
          options: [
            { name: Utils.getLookupName(CreditTypeLookup, CreditTypes.prepaid), value: CreditTypes.prepaid, class: 'label-credit-type-prepaid' },
            { name: Utils.getLookupName(CreditTypeLookup, CreditTypes.cod), value: CreditTypes.cod, class: 'label-credit-type-cod' },
            { name: Utils.getLookupName(CreditTypeLookup, CreditTypes.account), value: CreditTypes.account, class: 'label-credit-type-account' }
          ]
        }
      ],
      columnList: [
        { title: "Number", data: "sequenceNumber" },
        { title: "Contact", data: "contact.name" },
        { title: "Reference No.", data: "customerRef" },
        { title: "Status", data: "status" },
        { title: "Credit Type", data: "creditType" },
        { title: 'Location', data: 'accountLocationId' },
        { title: "Invoiced", data: "dateInvoiceCreated", dateFilter: true, type: 'datetime' },
        { title: "Due Date", data: "dateDue", dateFilter: true, type: 'date' },
        { title: "Total", data: "totalPrice", type: 'currency', totalField: 'totalInvoicePrice' },
        { title: "Amount Due", data: "amountDue", type: 'currency', totalField: 'totalInvoiceAmountDue' },
      ]
    }
  },
  methods: {
    isInvoiceOverdue(dateDue, status) {
      if(status != InvoiceStatusTypes.invoiced)
        return false
      let due = moment(dateDue)
      if(due.isValid())
        return due.isBefore(moment())
      return false
    }
  }
};
</script>
